import { render, staticRenderFns } from "./IntegrationMessageConfigEdit.vue?vue&type=template&id=b004d154&"
import script from "./IntegrationMessageConfigEdit.vue?vue&type=script&lang=js&"
export * from "./IntegrationMessageConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports